var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C3.13409 14 0 10.8659 0 7C0 3.13409 3.13409 0 7 0C10.8659 0 14 3.13409 14 7C14 10.8659 10.8659 14 7 14ZM7 1.27273C3.83409 1.27273 1.27273 3.83409 1.27273 7C1.27273 10.1659 3.83409 12.7273 7 12.7273C10.1659 12.7273 12.7273 10.1659 12.7273 7C12.7273 3.83409 10.1659 1.27273 7 1.27273Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00013 10.6589C6.65013 10.6589 6.36377 10.3725 6.36377 10.0225V6.36341C6.36377 6.01341 6.65013 5.72705 7.00013 5.72705C7.35013 5.72705 7.6365 6.01341 7.6365 6.36341V10.0225C7.6365 10.3725 7.35013 10.6589 7.00013 10.6589Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00013 4.93191C7.35159 4.93191 7.6365 4.647 7.6365 4.29554C7.6365 3.94409 7.35159 3.65918 7.00013 3.65918C6.64868 3.65918 6.36377 3.94409 6.36377 4.29554C6.36377 4.647 6.64868 4.93191 7.00013 4.93191Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 5.09091C6.55459 5.09091 6.20459 4.74091 6.20459 4.29545C6.20459 3.85 6.55459 3.5 7.00004 3.5C7.4455 3.5 7.7955 3.85 7.7955 4.29545C7.7955 4.74091 7.4455 5.09091 7.00004 5.09091ZM7.00004 3.81818C6.72959 3.81818 6.52277 4.025 6.52277 4.29545C6.52277 4.56591 6.72959 4.77273 7.00004 4.77273C7.2705 4.77273 7.47732 4.56591 7.47732 4.29545C7.47732 4.025 7.2705 3.81818 7.00004 3.81818Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.2bd178798d22875f94a9c8af1f806c5b.svg";
export { ForwardRef as ReactComponent };